/* Naverti theme interactions: mobile menu, product gallery, how-to-use path, testimonial swipe rows,
   purchase forms, "order" buttons that lead back to the purchase form, and the sticky buy bar. Prices come from the
   [data-buy-config] JSON that sections/main-product.liquid renders from the
   product's variants and Subscribe & Save plans. */
(function () {
  "use strict";

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }
  function setText(selector, text) {
    qsa(selector).forEach(function (el) {
      el.textContent = text;
    });
  }

  /* ---------- Mobile menu (native <dialog>) ---------- */

  var menu = document.querySelector("[data-menu]");
  var menuButton = document.querySelector("[data-menu-open]");

  if (menu && menuButton) {
    menuButton.addEventListener("click", function () {
      if (!menu.open) menu.showModal();
      menuButton.setAttribute("aria-expanded", "true");
    });
    menu.addEventListener("close", function () {
      menuButton.setAttribute("aria-expanded", "false");
    });
    menu.addEventListener("click", function (event) {
      if (event.target === menu) menu.close(); // backdrop
      if (event.target.closest("[data-menu-close], [data-menu-link]")) menu.close();
    });
  }

  /* ---------- Product gallery ---------- */

  qsa("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    var status = gallery.querySelector("[data-gallery-status]");
    var thumbs = qsa("[data-gallery-thumb]", gallery);
    var active = 0;
    if (!main || thumbs.length < 2) return;
    var strip = thumbs[0].closest("ul");

    function show(index) {
      active = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[active];
      main.srcset = thumb.getAttribute("data-srcset");
      main.src = thumb.getAttribute("data-src");
      main.alt = thumb.getAttribute("data-alt");
      thumbs.forEach(function (t, i) {
        if (i === active) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
      if (status) status.textContent = "Image " + (active + 1) + " of " + thumbs.length + ": " + main.alt;
      // Keep the active thumbnail in view without scrolling the page.
      if (strip) {
        var s = strip.getBoundingClientRect();
        var t = thumb.getBoundingClientRect();
        strip.scrollBy({ left: t.left - s.left - (s.width - t.width) / 2, behavior: "smooth" });
      }
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        show(index);
      });
    });
    gallery.querySelector("[data-gallery-prev]").addEventListener("click", function () {
      show(active - 1);
    });
    gallery.querySelector("[data-gallery-next]").addEventListener("click", function () {
      show(active + 1);
    });
    gallery.addEventListener("keydown", function (event) {
      if (event.key === "ArrowRight") show(active + 1);
      if (event.key === "ArrowLeft") show(active - 1);
    });

    // Horizontal swipe on the main image (vertical moves still scroll the page).
    var start = null;
    main.parentElement.addEventListener(
      "touchstart",
      function (event) {
        start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      },
      { passive: true }
    );
    main.parentElement.addEventListener(
      "touchend",
      function (event) {
        if (!start) return;
        var dx = event.changedTouches[0].clientX - start.x;
        var dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(active + (dx < 0 ? 1 : -1));
      },
      { passive: true }
    );
  });

  /* ---------- How-to-use path: fills in as the section scrolls by ---------- */

  qsa("[data-path]").forEach(function (path) {
    var track = path.querySelector("[data-path-track]");
    var fill = path.querySelector("[data-path-fill]");
    var steps = qsa("[data-path-step]", path);
    if (!track || !fill || steps.length < 2) return;
    var desktop = window.matchMedia("(min-width: 1024px)");
    var queued = false;
    var MARKER = 20; // half of the 40px step marker

    // Run the track from the first marker's center to the last one's.
    function layout() {
      var box = path.getBoundingClientRect();
      var last = steps[steps.length - 1].getBoundingClientRect();
      track.style.right = desktop.matches ? box.right - (last.left + MARKER) + "px" : "";
      track.style.bottom = desktop.matches ? "" : box.bottom - (last.top + MARKER) + "px";
    }
    function update() {
      queued = false;
      var vh = window.innerHeight;
      var t = track.getBoundingClientRect();
      // Desktop: fills while the row moves from 85% to 40% of the screen height.
      // Phones: follows a reading line at 60% of the screen height.
      var line = vh * 0.6;
      var f = desktop.matches ? (vh * 0.85 - t.top) / (vh * 0.45) : (line - t.top) / Math.max(t.height, 1);
      f = Math.max(0, Math.min(1, f));
      fill.style.width = desktop.matches ? f * 100 + "%" : "";
      fill.style.height = desktop.matches ? "" : f * 100 + "%";
      steps.forEach(function (step, i) {
        var reached = desktop.matches ? f >= i / (steps.length - 1) - 0.02 : step.getBoundingClientRect().top + MARKER <= line;
        step.toggleAttribute("data-active", f > 0 && reached);
      });
    }
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }
    layout();
    update();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", function () {
      layout();
      schedule();
    });
  });

  /* ---------- Swipe rows with prev/next and a progress bar (testimonials) ---------- */

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function initCarousels(root) {
    qsa("[data-carousel]", root).forEach(function (carousel) {
      if (carousel.hasAttribute("data-carousel-ready")) return;
      carousel.setAttribute("data-carousel-ready", "");
      var track = carousel.querySelector("[data-carousel-track]");
      var controls = carousel.querySelector("[data-carousel-controls]");
      var bar = carousel.querySelector("[data-carousel-bar]");
      var prev = carousel.querySelector("[data-carousel-prev]");
      var next = carousel.querySelector("[data-carousel-next]");
      if (!track || !controls) return;

      // One page = as many whole cards as fit in the visible width.
      var page = function () {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        var size = item.getBoundingClientRect().width + gap;
        return Math.max(1, Math.floor((track.clientWidth + gap) / size)) * size;
      };
      var go = function (direction) {
        track.scrollBy({ left: direction * page(), behavior: reduceMotion.matches ? "auto" : "smooth" });
      };
      var queued = false;
      var update = function () {
        queued = false;
        var max = track.scrollWidth - track.clientWidth;
        controls.hidden = max <= 2;
        if (max <= 2) return;
        bar.style.width = (track.clientWidth / track.scrollWidth) * 100 + "%";
        bar.style.left = (Math.min(track.scrollLeft, max) / track.scrollWidth) * 100 + "%";
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      var schedule = function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      };
      prev.addEventListener("click", function () {
        go(-1);
      });
      next.addEventListener("click", function () {
        go(1);
      });
      track.addEventListener("keydown", function (event) {
        if (event.target !== track) return;
        if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
          event.preventDefault();
          go(event.key === "ArrowLeft" ? -1 : 1);
        }
      });
      track.addEventListener("scroll", schedule, { passive: true });
      window.addEventListener("resize", schedule);
      update();
    });
  }

  initCarousels(document);
  // Theme editor: sections are re-rendered on every change, and a selected block should come into view.
  document.addEventListener("shopify:section:load", function (event) {
    initCarousels(event.target);
  });
  document.addEventListener("shopify:block:select", function (event) {
    var track = event.target.closest && event.target.closest("[data-carousel-track]");
    if (!track) return;
    var offset = event.target.getBoundingClientRect().left - track.getBoundingClientRect().left;
    track.scrollTo({ left: track.scrollLeft + offset - (parseFloat(window.getComputedStyle(track).paddingLeft) || 0), behavior: "smooth" });
  });

  /* ---------- Purchase forms (hero + repeat block) ---------- */

  var configElement = document.querySelector("[data-buy-config]");
  var forms = qsa("[data-buy]");
  if (!configElement || !forms.length) return;

  var config = JSON.parse(configElement.textContent);
  var bundles = config.bundles;
  var currency = new Intl.NumberFormat("en-US", { style: "currency", currency: config.currency || "USD" });

  function money(cents) {
    return currency.format(cents / 100);
  }
  function bundle(bottles) {
    for (var i = 0; i < bundles.length; i++) {
      if (bundles[i].bottles === bottles) return bundles[i];
    }
    return null;
  }
  function cents(mode, b) {
    return mode === "subscription" ? b.subscriptionCents : b.oneTimeCents;
  }
  function perBottle(mode, b) {
    return Math.round(cents(mode, b) / b.bottles);
  }
  function bestValue(mode) {
    var best = null;
    bundles.forEach(function (b) {
      var per = perBottle(mode, b);
      if (!best || per < best.per) best = { bottles: b.bottles, per: per };
    });
    return best && best.bottles;
  }
  function bottlesLabel(n) {
    return n === 1 ? "1 bottle" : n + " bottles";
  }
  function capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  var shippingPhrase = config.freeShipping ? "with free shipping" : "plus shipping";

  function readForm(form) {
    var mode = form.querySelector('input[name="purchase_option"]:checked');
    var bottles = form.querySelector('input[name="id"]:checked');
    return {
      mode: config.hasSubscription ? (mode ? mode.value : null) : "one-time",
      bottles: bottles ? Number(bottles.getAttribute("data-bottles")) : null,
    };
  }
  function complete(s) {
    var b = bundle(s.bottles);
    if (!b || !b.available) return false;
    return s.mode === "one-time" || (s.mode === "subscription" && config.hasSubscription && Boolean(b.plan));
  }

  // One selection for every form on the page; the first form (the hero) is the source of truth on load,
  // which also picks up a selection the browser restored after Back or a reload.
  var selection = readForm(forms[0]);

  function render() {
    var s = selection;
    var isSub = s.mode === "subscription";
    var shownMode = s.mode || "subscription";
    var best = bestValue(shownMode);
    var current = bundle(s.bottles);

    forms.forEach(function (form) {
      qsa('input[name="purchase_option"]', form).forEach(function (input) {
        input.checked = input.value === s.mode;
      });
      qsa('input[name="id"]', form).forEach(function (input) {
        input.checked = Number(input.getAttribute("data-bottles")) === s.bottles;
      });
      qsa("[data-bundle]", form).forEach(function (card) {
        var b = bundle(Number(card.getAttribute("data-bundle")));
        if (!b) return;
        card.querySelector("[data-bundle-price]").textContent = money(cents(shownMode, b));
        card.querySelector("[data-bundle-per]").textContent = b.available ? money(perBottle(shownMode, b)) + "/bottle" : "Sold out";
        card.querySelector("[data-best-badge]").hidden = b.bottles !== best;
      });
      var plan = form.querySelector("[data-selling-plan]");
      if (plan) {
        plan.value = isSub && current && current.plan ? String(current.plan) : "";
        plan.disabled = !plan.value;
      }
    });
    if (!complete(s)) return;

    var price = cents(s.mode, current);
    var qty = bottlesLabel(s.bottles);
    var meta = qty + " · " + config.tabletsPerBottle * s.bottles + " tablets · " + money(perBottle(s.mode, current)) + " per bottle";
    var save = current.oneTimeCents - (current.subscriptionCents || current.oneTimeCents);

    setText("[data-buy-price]", money(price));
    setText("[data-buy-price-text]", money(price));
    setText("[data-buy-compare]", money(current.oneTimeCents));
    setText("[data-buy-save]", "Save " + money(save) + " (" + Math.floor((save * 100) / current.oneTimeCents) + "%)");
    setText("[data-buy-meta]", meta);
    setText("[data-buy-plan]", capitalize(qty) + " delivered " + config.every + " for " + money(price) + " " + shippingPhrase + ".");
    qsa("[data-sub-only]").forEach(function (el) {
      el.hidden = !isSub;
    });
    qsa("[data-one-only]").forEach(function (el) {
      el.hidden = isSub;
    });

    setText("[data-sticky-mode]", isSub ? "Subscribe & Save" : "One-Time Purchase");
    setText("[data-sticky-qty]", qty);
    setText("[data-sticky-price]", money(price));
    qsa("[data-buy-image]").forEach(function (img) {
      img.srcset = current.image.srcset;
      img.src = current.image.src;
    });
  }

  // The store has no cart step: empty the cart, add the chosen pack (with its
  // Subscribe & Save plan) and open the checkout.
  function checkout(s) {
    var b = bundle(s.bottles);
    var item = { id: b.variant, quantity: 1 };
    if (s.mode === "subscription") item.selling_plan = b.plan;
    var json = { "Content-Type": "application/json", Accept: "application/json" };
    return fetch(config.routes.cartClear, { method: "POST", headers: json })
      .then(function () {
        return fetch(config.routes.cartAdd, { method: "POST", headers: json, body: JSON.stringify({ items: [item] }) });
      })
      .then(function (response) {
        if (response.ok) {
          window.location.assign(config.routes.checkout);
          return;
        }
        return response.json().then(function (data) {
          throw new Error((data && (data.description || data.message)) || "");
        });
      });
  }

  var busy = false;
  function setBusy(on) {
    busy = on;
    qsa("[data-buy-submit], [data-sticky-submit]").forEach(function (button) {
      if (on) button.setAttribute("aria-disabled", "true");
      else button.removeAttribute("aria-disabled");
    });
    setText("[data-buy-submit-label]", on ? "Opening checkout…" : "Continue to checkout");
  }
  function showError(form, message) {
    var error = form.querySelector("[data-buy-error]");
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }
  function go(form, s) {
    if (busy) return;
    setBusy(true);
    checkout(s).catch(function (err) {
      setBusy(false);
      showError(form, (err && err.message) || "Something went wrong. Please try again.");
    });
  }

  forms.forEach(function (form) {
    var error = form.querySelector("[data-buy-error]");

    form.addEventListener("change", function (event) {
      var input = event.target;
      if (input.name === "purchase_option") selection.mode = input.value;
      else if (input.name === "id") selection.bottles = Number(input.getAttribute("data-bottles"));
      else return;
      if (error) error.hidden = true;
      render();
    });

    // Submitted by its own button or by the sticky bar (form="buy-main").
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var s = readForm(form);
      if (!complete(s)) {
        showError(form, "Choose a purchase option and how many bottles.");
        var options = form.querySelector("[data-buy-options]");
        if (options) {
          options.scrollIntoView({ behavior: "smooth", block: "center" });
          var first = options.querySelector("input:not([disabled])");
          if (first) first.focus({ preventScroll: true });
        }
        return;
      }
      go(form, s);
    });
  });

  // Every "order" button on the page (snippets/order-button, "Get Up to 66% Off", the header's
  // "Shop now") is a #buy link: the browser scrolls to the purchase form at the top, whose own
  // button is the only one that opens the checkout. A short ring then shows where the shopper
  // landed. An offer link ([data-offer-link]) also selects the pack that gives its saving.
  var buyBox = document.getElementById("buy");
  var flashTimer;
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest('a[href="#buy"]');
    if (!link || !buyBox) return;
    if (link.hasAttribute("data-offer-link")) {
      var s = { mode: link.getAttribute("data-mode"), bottles: Number(link.getAttribute("data-bottles")) };
      if (complete(s)) {
        selection = { mode: s.mode, bottles: s.bottles };
        render();
      }
    }
    buyBox.removeAttribute("data-flash");
    void buyBox.offsetWidth; // restarts the ring when clicked again
    buyBox.setAttribute("data-flash", "");
    window.clearTimeout(flashTimer);
    flashTimer = window.setTimeout(function () {
      buyBox.removeAttribute("data-flash");
    }, 3500);
  });

  // Coming back from the checkout with Back restores this page from the cache.
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) setBusy(false);
  });

  render();

  /* ---------- Sticky buy bar ---------- */

  // Shown once the hero's checkout button has scrolled above the screen; hidden again
  // while a section with its own buy button ([data-hides-sticky]) is on screen,
  // so two buy buttons never compete.
  var bar = document.querySelector("[data-sticky-bar]");
  var mainButton = document.querySelector("#buy-main [data-buy-submit]");
  var ownButtons = qsa("[data-hides-sticky]");

  // Measured on scroll rather than with IntersectionObserver: a jump from below the
  // button to above it (anchor links, "back to top") never crosses it, so an
  // observer would not fire and the bar could stay up over the hero.
  if (bar && mainButton) {
    var queued = false;
    var update = function () {
      queued = false;
      var passedMain = mainButton.getBoundingClientRect().bottom < 0;
      var covered = ownButtons.some(function (section) {
        var r = section.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      });
      var visible = passedMain && !covered;
      if (visible === bar.hasAttribute("data-visible")) return;
      bar.toggleAttribute("data-visible", visible);
      bar.inert = !visible;
    };
    var schedule = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    update();
  }
})();
